import React from "react";
import LiftsContainerComponent from "../components/lift/liftsContainer";

export const LiftsPage = () => {
  return (
    <LiftsContainerComponent />
  );
};